import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthViewComponent } from '../components/auth-view/auth-view.component';
import { ResetPasswordFormComponent } from './components/reset-password-form/reset-password-form.component';

@Component({
  selector: 'app-reset-password',
  imports: [ResetPasswordFormComponent, AuthViewComponent, RouterLink],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent {}
